import { useController, useFormContext } from 'react-hook-form';
import { MgSupplierItemPackage, Unit } from '@retail/products/types';
import { Stack } from '@mui/material';
import { FreightConditionPercentAddonInput } from './FreightConditionPercentAddonInput';
import { FixedAddonFreightForm } from './FixedAddonFreightForm';
import { CreateFreightConditionSchema } from './freightConditionSchema';
import { useCallback, useMemo } from 'react';
import { SelectFreightTypeRadio } from '../SelectFreightTypeRadio';
import { ConditionDatesForm } from '@retail/calculus/components';

interface Props {
  supplierItemPackages: MgSupplierItemPackage[];
  globalItemUnits: Unit[];
}

export function FreightConditionForm({ supplierItemPackages, globalItemUnits }: Props) {
  const { control, resetField } = useFormContext<CreateFreightConditionSchema>();
  const freightTypeController = useController({ name: 'freightType', control });

  const unitsForFixedAddon = useMemo(() => {
    const supplierItemUnits = supplierItemPackages
      ? supplierItemPackages.map((pkge) => {
          return { ...pkge.unit };
        })
      : [];
    return [...supplierItemUnits, ...globalItemUnits];
  }, [globalItemUnits, supplierItemPackages]);

  const handleSelectFreightType = useCallback(
    (type: string) => {
      resetField('percentAddon');
      resetField('fixedAddon');
      resetField('fixedAddonUnit');
      freightTypeController.field.onChange(type);
    },
    [freightTypeController.field, resetField]
  );

  return (
    <form>
      <Stack flexDirection="column" gap={3}>
        <SelectFreightTypeRadio
          error={freightTypeController.fieldState.error}
          value={freightTypeController.field.value}
          handleSelectFreightType={handleSelectFreightType}
        />
        {freightTypeController.field.value === 'percent' && <FreightConditionPercentAddonInput />}
        {freightTypeController.field.value === 'fixed_addon' && (
          <FixedAddonFreightForm unitsForFixedAddon={unitsForFixedAddon} />
        )}
        <ConditionDatesForm excludeToDate defaultFromDate={new Date()} inputFieldWidth={400} />
      </Stack>
    </form>
  );
}
